import tradingview from "@/components/Exchange/Tradingview/Tradingview";

// old version of tradingview.


// import { mapActions } from "vuex";
// import { DataFeed, widget as TvWidget } from "tradingview-api";
// var Stomp = require("stompjs");
// var SockJS = require("sockjs-client");
//
// const supported_resolutions = [
//   "1",
//   "5",
//   "15",
//   "30",
//   "60",
//   "240",
//   "1D",
//   "1W",
//   "1M",
// ];
// const intervalMap = {
//   "1min": "1",
//   "5min": "5",
//   "15min": "15",
//   "30min": "30",
//   "1hour": "60",
//   // '60min': '60',
//   "4hour": "240",
//   "1day": "1D",
//   "1week": "1W",
//   "1month": "1M",
//   // '1mon': '1M'
// };
//
// export default {
//   name: "local-tradingview",
//   props: {
//     symbol: {
//       type: String,
//     },
//     stompSocket: {
//       type: Object,
//     },
//     coinScale: {
//       type: Number,
//     },
//     loading: {
//         type: Boolean
//     }
//   },
//   data() {
//     return {
//       subscribtion: {},
//       widget: null,
//       interval: "5min",
//       datafeed: new DataFeed({
//         getBars: (params) => this.getBars(params),
//         fetchResolveSymbol: () => this.resolveSymbol(),
//         fetchConfiguration: () => {
//           return new Promise((resolve) => {
//             resolve({
//               supported_resolutions,
//             });
//           });
//         },
//       }),
//     };
//   },
//   computed: {},
//   mounted() {
//     this.getKline();
//   },
//   methods: {
//     ...mapActions({
//       getKLineData: "tradingView/GET_KLINES_DATA",
//     }),
//     resolveSymbol() {
//       return new Promise((resolve) => {
//         const symbol = this.symbol;
//         resolve({
//           name: symbol.toLocaleUpperCase(),
//           full_name: symbol.toLocaleUpperCase(),
//           description: symbol.toLocaleUpperCase(),
//           type: symbol,
//           session: "24x7",
//           exchange: "Excoino",
//           pricescale: Math.pow(10, this.coinScale),
//           listed_exchange: symbol,
//           timezone: "Asia/Tehran",
//           format: "price",
//           minmov: 1,
//           // volume_precision: info['value-precision'],
//           has_intraday: true,
//           supported_resolutions,
//           has_weekly_and_monthly: true,
//         });
//       });
//     },
//     async getBars(params) {
//       const symbol = this.symbol;
//       const size = window.innerWidth;
//       if (
//         !params.firstDataRequest /** Whether to request historical data for the first time */
//       ) {
//         // Huobi API temporarily does not support segmented query historical data
//         return {
//           bars: [],
//           meta: {
//             noData: true,
//           },
//         };
//       }
//       if (params.resolution !== intervalMap[this.interval]) {
//         this.unsubscribeKLine();
//         for (const key in intervalMap) {
//           if (intervalMap[key] === params.resolution) {
//             this.interval = key;
//           }
//         }
//       }
//       const res = await this.getKLineData({
//         symbol,
//         from: params.from * 1000,
//         to: params.firstDataRequest ? new Date().getTime() : params.to * 1000,
//         resolution: intervalMap[this.interval],
//         size: size > 2000 ? 2000 : size,
//       });
//       if (
//         params.resolution === intervalMap[this.interval] &&
//         params.firstDataRequest &&
//         res.data &&
//         res.data.length
//       ) {
//         this.subscribeKLine(this.interval);
//       }
//
//       document.getElementById("chart_wrapper").classList.add("d-block");
//       this.$emit("chartsLoading");
//
//       if (!res.data || !res.data.length) {
//         return {
//           bars: [],
//           meta: { noData: true },
//         };
//       }
//       const list = [];
//       for (let i = 0; i < res.data.length; i++) {
//         const item = res.data[i];
//         if (params.resolution === "1D") {
//           list.push({
//             time: item[0] + 12600000,
//             open: item[1],
//             high: item[2],
//             low: item[3],
//             close: item[4],
//             volume: item[5],
//           });
//         } else if (params.resolution === "1W") {
//           list.push({
//             time: item[0] + 99000000,
//             open: item[1],
//             high: item[2],
//             low: item[3],
//             close: item[4],
//             volume: item[5],
//           });
//         } else if (params.resolution === "1M") {
//           list.push({
//             time: item[0] + 16200000,
//             open: item[1],
//             high: item[2],
//             low: item[3],
//             close: item[4],
//             volume: item[5],
//           });
//         } else {
//           list.push({
//             time: item[0],
//             open: item[1],
//             high: item[2],
//             low: item[3],
//             close: item[4],
//             volume: item[5],
//           });
//         }
//       }
//       list.sort((l, r) => (l.time > r.time ? 1 : -1));
//       return {
//         bars: list,
//         meta: {
//           noData: !list.length,
//         },
//       };
//     },
//     getKline() {
//       let config = {
//         autosize: true,
//         height: 320,
//         fullscreen: true,
//         theme: "dark",
//         studies_overrides: {
//           "volume.show ma": true,
//         },
//         disabled_features: [
//           "header_compare"
//         ],
//         symbol: this.symbol.toLocaleUpperCase(),
//         interval: intervalMap[this.interval], // default candlestick period
//         timezone: "Asia/Tehran",
//         // toolbar_bg: "#18202a",
//         container_id: "tv_chart_container",
//         datafeed: this.datafeed,
//         library_path: "/charting_library/",
//         locale: "en",
//         debug: false,
//       };
//
//       this.widget = new TvWidget(config);
//     },
//     subscribeKLine(resolution) {
//       // const symbol = this.symbol
//
//       // if (this.stompClient) {
//       //   this.stompClient.ws.close();
//       // }
//       // var stompClient = null;
//       // let scale = that.baseCoinScale;
//       // console.log(new SockJS("wss://api-fa-market-dev.ernyka.com/market/market-ws/websocket"));
//       // var socket = new SockJS("wss://api-fa-market-dev.ernyka.com/market/market-ws/websocket");
//
//       // stompClient = Stomp.over(socket);
//       // this.stompClient = stompClient;
//       // stompClient.debug = false;
//       // stompClient.connect({}, (frame) =>
//       this.subscribtion = this.stompSocket.subscribe(
//         "/topic/market/kline/" + this.symbol + "/" + resolution,
//         (msg) => {
//           // if (resolution != "1") return;
//           // if (that.currentBar != null) onRealtimeCallback(that.currentBar);
//           var resp = JSON.parse(msg.body);
//           if (resolution === "1day") {
//             this.datafeed.updateKLine({
//               time: resp.time + 12600000,
//               open: resp.openPrice,
//               high: resp.highestPrice,
//               low: resp.lowestPrice,
//               close: resp.closePrice,
//               volume: resp.volume,
//             });
//           } else if (resolution === "1week") {
//             this.datafeed.updateKLine({
//               time: resp.time + 99000000,
//               open: resp.openPrice,
//               high: resp.highestPrice,
//               low: resp.lowestPrice,
//               close: resp.closePrice,
//               volume: resp.volume,
//             });
//           } else if (resolution === "1month") {
//             this.datafeed.updateKLine({
//               time: resp.time + 16200000,
//               open: resp.openPrice,
//               high: resp.highestPrice,
//               low: resp.lowestPrice,
//               close: resp.closePrice,
//               volume: resp.volume,
//             });
//           } else {
//             this.datafeed.updateKLine({
//               time: resp.time,
//               open: resp.openPrice,
//               high: resp.highestPrice,
//               low: resp.lowestPrice,
//               close: resp.closePrice,
//               volume: resp.volume,
//             });
//           }
//           // that.lastBar = {time:resp.time,open:resp.openPrice,high:resp.highestPrice,low:resp.lowestPrice,close:resp.closePrice,volume:resp.volume};
//           // that.currentBar = that.lastBar;
//           // onRealtimeCallback(that.lastBar);
//           // that.lastBar.newKlineStatus = true;
//         }
//       );
//       // });
//       // ws.subscribe(
//       //     `market.${symbol}.kline.${this.interval}`,
//       //     {
//       //       id: 'react-tv',
//       //       sub: `market.${symbol}.kline.${this.interval}`
//       //     },
//       //     (data) => {
//       //       const tick = data.tick
//       //       this.datafeed.updateKLine({
//       //         time: tick.id * 1000,
//       //         open: tick.open,
//       //         high: tick.high,
//       //         low: tick.low,
//       //         close: tick.close,
//       //         volume: tick.vol
//       //       })
//       //     }
//       // )
//     },
//     unsubscribeKLine() {
//       this.subscribtion.unsubscribe();
//       // const symbol = this.symbol
//       // ws.unsubscribe(`market.${symbol}.kline.${this.interval}`)
//     },
//   },
// };



// v29 of trading vuew chart global
// export default {
//   name: 'TradingViewChart',
//   mounted() {
//     this.loadScripts().then(() => {
//       this.initChart();
//     });
//   },
//   methods: {
//     getParameterByName(name) {
//       name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
//       const regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
//         results = regex.exec(window.location.search);
//       return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
//     },
//     loadScripts() {
//       // Dynamically load the required scripts
//       const script1 = this.loadScript('/charting_library/charting_library.standalone.js');
//       const script2 = this.loadScript('/datafeeds/udf/dist/bundle.js');
//       return Promise.all([script1, script2]);
//     },
//     loadScript(src) {
//       return new Promise((resolve, reject) => {
//         const script = document.createElement('script');
//         script.src = src;
//         script.onload = resolve;
//         script.onerror = reject;
//         document.head.appendChild(script);
//       });
//     },
//     initChart() {
//       const datafeedUrl = this.getParameterByName('dataUrl') || "https://demo-feed-data.tradingview.com";
//       const url = datafeedUrl.startsWith('https://') ? datafeedUrl : `https://${datafeedUrl}`;
//
//       const widget = new window.TradingView.widget({
//         fullscreen: true,
//         symbol: 'AAPL',
//         interval: '1D',
//         theme: "dark",
//         container: 'tv_chart_container',
//         datafeed: new window.Datafeeds.UDFCompatibleDatafeed(url, undefined, {
//           maxResponseLength: 1000,
//           expectedOrder: 'latestFirst',
//         }),
//         library_path: "/charting_library/",
//         locale: this.getParameterByName('lang') || "en",
//         disabled_features: ["use_localstorage_for_settings"],
//         enabled_features: ["study_templates"],
//         charts_storage_url: 'https://saveload.tradingview.com',
//         charts_storage_api_version: "1.1",
//         client_id: 'tradingview.com',
//         user_id: 'public_user_id',
//       });
//
//       // Optional: focus iframe
//       setTimeout(() => {
//         const iframe = document.querySelector('iframe');
//         if (iframe) iframe.focus();
//       }, 2000);
//     }
//   }
// };


// local trading view with market api
import { mapActions } from "vuex";
var Stomp = require("stompjs");
var SockJS = require("sockjs-client");

const supported_resolutions = [
  "1", "5", "15", "30", "60", "240", "1D", "1W", "1M",
];

const intervalMap = {
  "1min": "1",
  "5min": "5",
  "15min": "15",
  "30min": "30",
  "1hour": "60",
  "4hour": "240",
  "1day": "1D",
  "1week": "1W",
  "1month": "1M",
};

export default {
  name: 'TradingViewChart',
  props: {
    symbol: {
      type: String,
      default: 'BTCUSDT'
    },
    stompSocket: {
      type: Object,
    },
    coinScale: {
      type: Number,
      default: 8
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      subscription: {},
      widget: null,
      interval: "5min",
      datafeed: null,
      lastBar: null,
      currentBar: null,
      onRealtimeCallback: null,
      subscriberUID: null,
    };
  },
  mounted() {
    this.loadScripts().then(() => {
      this.initChart();
    });
  },
  methods: {
    ...mapActions({
      getKLineData: "tradingView/GET_KLINES_DATA",
    }),

    getParameterByName(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      const regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(window.location.search);
      return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    },

    loadScripts() {
      const script1 = this.loadScript('/charting_library/charting_library.standalone.js');
      return Promise.all([script1]);
    },

    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },

    createDatafeed() {
      const self = this;

      return {
        onReady: (callback) => {
          setTimeout(() => callback({
            supported_resolutions,
            supports_marks: false,
            supports_timescale_marks: false,
            supports_time: true,
          }), 0);
        },

        searchSymbols: (userInput, exchange, symbolType, onResultReadyCallback) => {
          onResultReadyCallback([]);
        },

        resolveSymbol: (symbolName, onSymbolResolvedCallback, onResolveErrorCallback) => {
          const symbolInfo = {
            name: self.symbol.toUpperCase(),
            full_name: self.symbol.toUpperCase(),
            description: self.symbol.toUpperCase(),
            type: 'crypto',
            session: '24x7',
            exchange: 'Excoino',
            pricescale: Math.pow(10, self.coinScale),
            listed_exchange: self.symbol,
            timezone: 'Asia/Tehran',
            format: 'price',
            minmov: 1,
            has_intraday: true,
            supported_resolutions,
            has_weekly_and_monthly: true,
            volume_precision: 2,
          };

          setTimeout(() => onSymbolResolvedCallback(symbolInfo), 0);
        },

        getBars: async (symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) => {
          const { from, to, firstDataRequest } = periodParams;

          if (!firstDataRequest) {
            onHistoryCallback([], { noData: true });
            return;
          }

          if (resolution !== intervalMap[self.interval]) {
            self.unsubscribeKLine();
            for (const key in intervalMap) {
              if (intervalMap[key] === resolution) {
                self.interval = key;
              }
            }
          }

          try {
            const size = window.innerWidth;
            const res = await self.getKLineData({
              symbol: self.symbol,
              from: from * 1000,
              to: firstDataRequest ? new Date().getTime() : to * 1000,
              resolution: intervalMap[self.interval],
              size: size > 2000 ? 2000 : size,
            });

            if (
              resolution === intervalMap[self.interval] &&
              firstDataRequest &&
              res.data &&
              res.data.length
            ) {
              self.subscribeKLine(self.interval);
            }

            self.$emit("chartsLoading");

            if (!res.data || !res.data.length) {
              onHistoryCallback([], { noData: true });
              return;
            }

            const bars = [];
            for (let i = 0; i < res.data.length; i++) {
              const item = res.data[i];
              let time = item[0];

              if (resolution === "1D") {
                time = item[0] + 12600000;
              } else if (resolution === "1W") {
                time = item[0] + 99000000;
              } else if (resolution === "1M") {
                time = item[0] + 16200000;
              }

              bars.push({
                time: time,
                open: item[1],
                high: item[2],
                low: item[3],
                close: item[4],
                volume: item[5],
              });
            }

            bars.sort((l, r) => (l.time > r.time ? 1 : -1));

            if (bars.length > 0) {
              self.lastBar = bars[bars.length - 1];
            }

            onHistoryCallback(bars, { noData: !bars.length });
          } catch (error) {
            console.error('Error fetching bars:', error);
            onErrorCallback(error);
          }
        },

        subscribeBars: (symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) => {
          self.onRealtimeCallback = onRealtimeCallback;
          self.subscriberUID = subscriberUID;
        },

        unsubscribeBars: (subscriberUID) => {
          self.unsubscribeKLine();
          self.onRealtimeCallback = null;
          self.subscriberUID = null;
        },

        updateKLine: (bar) => {
          if (self.onRealtimeCallback) {
            self.onRealtimeCallback(bar);
          }
        }
      };
    },

    initChart() {
      this.datafeed = this.createDatafeed();

      const widget = new window.TradingView.widget({
        fullscreen: true,
        autosize: true,
        height: 320,
        symbol: this.symbol.toUpperCase(),
        interval: intervalMap[this.interval],
        theme: "dark",
        container: 'tv_chart_container',
        datafeed: this.datafeed,
        library_path: "/charting_library/",
        locale: this.getParameterByName('lang') || "en",
        timezone: "Asia/Tehran",
        disabled_features: ["use_localstorage_for_settings", "header_compare"],
        enabled_features: ["study_templates"],
        studies_overrides: { "volume.show ma": true },
        debug: false,
      });

      this.widget = widget;

      widget.onChartReady(() => {
        console.log("Chart ready!");

        const savedLayout = localStorage.getItem("tradingview_layout");
        if (savedLayout) {
          try {
            const parsed = JSON.parse(savedLayout);
            widget.load(parsed);
            console.log("Loaded layout from LocalStorage");
          } catch (e) {
            console.warn("Invalid layout in localStorage, clearing it");
            localStorage.removeItem("tradingview_layout");
          }
        }

        const chart = widget.chart();

        const saveLayout = () => {
          if (typeof widget.save === "function") {
            try {
              widget.save((data) => {
                try {
                  localStorage.setItem("tradingview_layout", JSON.stringify(data));
                  console.log("Saved chart layout");
                } catch (err) {
                  console.error("Failed to save layout", err);
                }
              });
            } catch (err) {
              console.warn("widget.save() not ready", err);
            }
          }
        };

        chart.onIntervalChanged().subscribe(null, saveLayout);
        chart.onSymbolChanged().subscribe(null, saveLayout);

        setInterval(saveLayout, 10000);
      });
    },

    subscribeKLine(resolution) {
      if (!this.stompSocket) return;

      this.subscription = this.stompSocket.subscribe(
        "/topic/market/kline/" + this.symbol + "/" + resolution,
        (msg) => {
          const resp = JSON.parse(msg.body);
          let time = resp.time;

          if (resolution === "1day") {
            time = resp.time + 12600000;
          } else if (resolution === "1week") {
            time = resp.time + 99000000;
          } else if (resolution === "1month") {
            time = resp.time + 16200000;
          }

          const bar = {
            time: time,
            open: resp.openPrice,
            high: resp.highestPrice,
            low: resp.lowestPrice,
            close: resp.closePrice,
            volume: resp.volume,
          };

          this.lastBar = bar;
          this.currentBar = bar;

          if (this.datafeed && this.datafeed.updateKLine) {
            this.datafeed.updateKLine(bar);
          }
        }
      );
    },

    unsubscribeKLine() {
      if (this.subscription && this.subscription.unsubscribe) {
        this.subscription.unsubscribe();
      }
    },
  },

  beforeDestroy() {
    this.unsubscribeKLine();
    if (this.widget) {
      this.widget.remove();
    }
  }
};

